const { SITE_BASE_URL } = require('./brokerConnectionSource');

// Finished approved-generator assets only. Never synthesize marketing images at build time.
function socialImageForPath(pathname, baseUrl = SITE_BASE_URL) {
  if (pathname === '/courses/ai-trading-bootcamp') {
    return {
      url: `${baseUrl}/images/courses/ai-trading-bootcamp-share.png`,
      width: 1536,
      height: 864,
      type: 'image/png',
      alt: 'AI Trading Bootcamp. Live with Rob Grzesik. BotSpot.',
    };
  }
  return {
    url: `${baseUrl}/social-share-image.jpg`,
    width: 1536,
    height: 1024,
    type: 'image/jpeg',
    alt: 'BotSpot AI Trading Agents',
  };
}
function ogImageUrlForPath(pathname, baseUrl = SITE_BASE_URL) {
  return socialImageForPath(pathname, baseUrl).url;
}
module.exports = { ogImageUrlForPath, socialImageForPath };
